import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, Grid, Skeleton } from '@mui/material';
import  LoadingButton  from '@mui/material/Button';
import StopIcon from '@mui/icons-material/Stop';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

interface SpeakButtonProps {
  text: string//() => string;
  label?: string;
  sx?: object;
  id?: string;
  stop?: boolean; // If true, will stop speaking if already speaking
}

export const SpeakButton: React.FC<SpeakButtonProps> = ({
  text,
  label = 'Speak Text',
  sx = {},
  id = 'speak_button',
  stop = false, // If true, will stop speaking if already speaking
}) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const currentTextRef = useRef<string | null>(null);
  const utteranceRef = useRef<SpeechSynthesisUtterance | null>(null);

  const startSpeaking = (textToSpeak: string) => {
    const utterance = new SpeechSynthesisUtterance(textToSpeak);
    utteranceRef.current = utterance;

    utterance.onstart = () => {
      currentTextRef.current = textToSpeak;
      setIsSpeaking(true);
    };

    utterance.onend = () => {
      setIsSpeaking(false);
      currentTextRef.current = null;
      utteranceRef.current = null;
    };

    utterance.onerror = () => {
      currentTextRef.current = null;
      utteranceRef.current = null;
      if (isSpeaking) {
        setIsSpeaking(false);
        alert('An error occurred during speech synthesis.');
      }
    };

    window.speechSynthesis.speak(utterance);
  };

  const handleClick = () => {
    if (!('speechSynthesis' in window)) {
      alert('Your browser does not support text-to-speech.');
      return;
    }

    //const newText = text();

    if (isSpeaking) {
      // If text is different, just stop speaking (don't start new)
      // if (currentTextRef.current !== newText) {
      //   setIsSpeaking(false);
      //   window.speechSynthesis.cancel();
      //   currentTextRef.current = null;
      //   utteranceRef.current = null;
      //   return;
      // }
      // If same text, toggle stop
      setIsSpeaking(false);
      window.speechSynthesis.cancel();
      currentTextRef.current = null;
      utteranceRef.current = null;
      return;
    }

    // Not speaking: start immediately
    startSpeaking(text);
  };

  useEffect(() => {
       if (stop || (window.speechSynthesis.speaking  && currentTextRef.current !== text)) {
        setIsSpeaking(false);
        window.speechSynthesis.cancel();
        currentTextRef.current = null;
        utteranceRef.current = null;
      }
    
  }, [window.speechSynthesis?.speaking, text, stop]);

 useEffect(() => {
   return () => {
      //if (stop || (window.speechSynthesis.speaking  && currentTextRef.current !== text)) {
        setIsSpeaking(false);
        window.speechSynthesis.cancel();
        currentTextRef.current = null;
        utteranceRef.current = null;
      //}
    };
  }, []);


  return (
    <LoadingButton
      id={id}
      size="small"
      startIcon={
        isSpeaking ? (
          <>
            <CircularProgress size={14} color="inherit" />
            <StopIcon sx={{ ml: 0.5, fontSize: 14 }} />
          </>
        ) : (
          <VolumeUpIcon sx={{ fontSize: 15 }} />
        )
      }
      variant="outlined"
      disableElevation
      sx={{
        fontSize: '12px',
        color: '#656EFF',
        borderColor: '#C5BEFF',
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 500,
        px: 1.5,
        '&:hover': { borderColor: '#656EFF', backgroundColor: '#F5F3FF' },
        ...sx
      }}
      onClick={handleClick}
    >
      {isSpeaking ? 'Stop' : label}
    </LoadingButton>
  );
};
